import {makeGetPlan} from 'main/factories/usecases/others/selection-flow/remote-plan-v3';
import {delay} from 'presentation/utils/delay';

export const getPlans = async (signal?: AbortSignal) => {
	const plans = await makeGetPlan().get({signal});

	const parsedPlans = plans?.planos?.map(plan => ({
		...plan,
		nmPlano: plan.nmPlano?.toUpperCase(),
	}));

	await delay(500);
	return parsedPlans;
};
